import {ValueObject} from '@s-ui/domain'

export default class SearchItemValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.title
   * @param {String} data.url
   */
}
